import { ChangeDetectionStrategy, Component, ElementRef, input, inject, effect } from '@angular/core';

import { ApInlineSvgDirective } from './inline-svg.directive';
import { ApInlineSvgService } from './inline-svg.service';

@Component({
    selector: 'ap-inline-svg',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApInlineSvgComponent {
    private readonly inlineSVGService = inject(ApInlineSvgService);

    /**
     * Required - The ApInlineSvgDirective
     */
    public readonly context = input.required<ApInlineSvgDirective>();

    /**
     * Required - Other HTMLElement | SVGElement to inject
     */
    public readonly content = input.required<HTMLElement | SVGElement>();

    /**
     * Should the svg replace the current contents of the parent node?
     * Defaults to false
     */
    public readonly replaceContents = input(false);

    /**
     * Should it prepend before the element be replaced?
     * Defaults to false
     */
    public readonly prepend = input(false);

    /** @internal */
    readonly element = inject(ElementRef);

    constructor() {
        effect(() => this.updateContent());
    }

    private updateContent(): void {
        this.inlineSVGService.insertElement(
            this.context(),
            this.element.nativeElement,
            this.content(),
            this.replaceContents(),
            this.prepend()
        );
    }
}
